import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 站点列表
export const getMenu = (params) => { return req("get", "/admin/permissions?"+getHttpParams(params)) };

//新增
export const addMenu = (params) => { return req("get", "/admin/permissions/create?"+getHttpParams(params)) };


export const updateMenu = (id, params) => { return req("patch", "/admin/permissions/"+id+'?'+getHttpParams(params)) };


export const deleteMenu = (id) => { return req("delete", "/admin/permissions/"+id) };

//获取曲线
export const getChart = (params) => { return req("get", "/admin/platform/getChart?"+getHttpParams(params)) };

//获取曲线
export const getDashboard = (params) => { return req("get", "/admin/platform?"+getHttpParams(params)) };



// WEBPACK FOOTER //
// ./src/api/menu.js